import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import DELETE_GUEST_ACQUISITION_QUERY from './DeleteGuestAcquisition.graphql';

export const useDeleteGuestAcquisition = (options) =>
  useCustomQuery(DELETE_GUEST_ACQUISITION_QUERY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'deleteGuestAcquisition',
  });
